module.exports = __webpack_public_path__ + "static/media/baseMeme6.47559c9f.jpg";